import { Tooltip, Typography } from 'antd';

import { IUserOptionProps } from './UserOption.types';

import './UserOption.styles.scss';

const { Text } = Typography;

const UserOption = ({ uid, aid, account_name, username, email, mobile_number, disabled }: IUserOptionProps) => {
  const classPrefix = 'np-users-autocomplete-option';
  const mainAccountClass = username === account_name ? `${classPrefix}__main-acc` : '';
  const disabledClass = disabled ? `${classPrefix}--disabled` : '';

  return (
    <div className={`${classPrefix} ${mainAccountClass} ${disabledClass}`}>
      <div className={`${classPrefix}__info-wrapper ${classPrefix}__info-wrapper--left`}>
        <div className={`${classPrefix}__info`}>
          <Text ellipsis>uid: {uid}</Text>
        </div>

        <div className={`${classPrefix}__description`}>
          <Text ellipsis>aid: {aid}</Text>
        </div>

        <Tooltip title={email}>
          <div className={`${classPrefix}__description`}>
            <Text ellipsis>{email}</Text>
          </div>
        </Tooltip>
      </div>

      <div className={`${classPrefix}__info-wrapper ${classPrefix}__info-wrapper--right`}>
        <Tooltip title={username}>
          <div className={`${classPrefix}__info`}>
            <Text ellipsis>{username}</Text>
          </div>
        </Tooltip>

        <Tooltip title={account_name}>
          <div className={`${classPrefix}__description`}>
            <Text ellipsis>{account_name}</Text>
          </div>
        </Tooltip>

        <Tooltip title={mobile_number}>
          <div className={`${classPrefix}__description`}>
            <Text ellipsis>{mobile_number}</Text>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default UserOption;
